<template>
  <div class="Fuell-Table" ref="table">
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'company_transaction_fields_table_transaction_field_name_header' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'company_transaction_fields_table_field_options_header' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'company_transaction_fields_table_include_in_transaction_type_header' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'company_transaction_fields_table_budgets_header' }"></span>
      </div>
      <div class="Fuell-Table--item"><span></span></div>
    </div>

    <transaction-fields-table-row
      v-for="transactionField in transactionFields"
      :transactionField="transactionField"
      @editCustomField="editCustomField"
      @deleteCustomField="deleteCustomField"
      :key="transactionField.id"
    ></transaction-fields-table-row>
    <div
      class="d-flex justify-content-center w-100 mt-4"
      v-if="currentPage < lastPage"
    >
      <span
        class="text-primary text-underline clickable"
        @click="nextPage"
      >{{$t('ACTION_LOAD_MORE')}}</span>
    </div>
  </div>
</template>

<script>
import TransactionFieldsTableRow from './TransactionFieldsTableRow'

export default {
  name: 'TransactionFieldsTable',
  components: { TransactionFieldsTableRow },
  computed: {
    transactionFields () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/transactionFields']
    },
    currentPage () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/transactionFieldsCurrentPage']
    },
    lastPage () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/transactionFieldsLastPage']
    },
    isCallingTransactionFields () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/isCallingTransactionFields']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('CompanyStore/TransactionFieldsStore/nextTransactionFieldsPage')
    },
    editCustomField (event) {
      this.$emit('editCustomField', event)
    },
    deleteCustomField (event) {
      this.$emit('deleteCustomField', event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/transaction-fields";
</style>
